module.exports = __webpack_public_path__ + "static/media/striped_bar_tall.46c79430.svg";